import { PaymentStatusType } from "@/types/graphql/partner.generated";

// Подписи (`payments.status.*`) и цвета чипа статуса платежа: одним набором
// пользуются список платежей и диалог деталей платежа.
export const PAYMENT_STATUS_KEY: Record<PaymentStatusType, string> = {
  [PaymentStatusType.PendingType]: "pending",
  [PaymentStatusType.SucceededType]: "succeeded",
  [PaymentStatusType.CanceledType]: "canceled",
  [PaymentStatusType.RefundedType]: "refunded",
};

export const PAYMENT_STATUS_COLOR: Record<
  PaymentStatusType,
  "default" | "success" | "error"
> = {
  [PaymentStatusType.PendingType]: "default",
  [PaymentStatusType.SucceededType]: "success",
  [PaymentStatusType.CanceledType]: "error",
  [PaymentStatusType.RefundedType]: "error",
};
